// Move power/category data for damage estimation
// Only includes moves that appear on preset teams or are competitively common
// category: 'physical' | 'special' | 'status'
// spread: hits both opponents in doubles (0.75x modifier)

const MOVE_DATA = {
  // Normal
  'Body Slam':      { power: 85, cat: 'physical', spread: false },
  'Boomburst':      { power: 140, cat: 'special', spread: true },
  'Double-Edge':    { power: 120, cat: 'physical', spread: false },
  'Explosion':      { power: 250, cat: 'physical', spread: true },
  'Extreme Speed':  { power: 80, cat: 'physical', spread: false, priority: 2 },
  'Facade':         { power: 70, cat: 'physical', spread: false },
  'Fake Out':       { power: 40, cat: 'physical', spread: false, priority: 3 },
  'Hyper Voice':    { power: 90, cat: 'special', spread: true },
  'Quick Attack':   { power: 40, cat: 'physical', spread: false, priority: 1 },
  'Population Bomb':{ power: 20, cat: 'physical', spread: false },
  'Return':         { power: 102, cat: 'physical', spread: false },
  // Fire
  'Blaze Kick':     { power: 85, cat: 'physical', spread: false },
  'Eruption':       { power: 150, cat: 'special', spread: true },
  'Fire Blast':     { power: 110, cat: 'special', spread: false },
  'Fire Punch':     { power: 75, cat: 'physical', spread: false, punch: true },
  'Flamethrower':   { power: 90, cat: 'special', spread: false },
  'Flare Blitz':    { power: 120, cat: 'physical', spread: false },
  'Heat Wave':      { power: 95, cat: 'special', spread: true },
  'Lava Plume':     { power: 80, cat: 'special', spread: true },
  'Mystical Fire':  { power: 75, cat: 'special', spread: false },
  'Overheat':       { power: 130, cat: 'special', spread: false },
  'Pyro Ball':      { power: 120, cat: 'physical', spread: false },
  'Torch Song':     { power: 80, cat: 'special', spread: false },
  'Bitter Blade':   { power: 90, cat: 'physical', spread: false },
  'Armor Cannon':   { power: 120, cat: 'special', spread: false },
  // Water
  'Aqua Jet':       { power: 40, cat: 'physical', spread: false, priority: 1 },
  'Aqua Tail':      { power: 90, cat: 'physical', spread: false },
  'Flip Turn':      { power: 60, cat: 'physical', spread: false },
  'Hydro Pump':     { power: 110, cat: 'special', spread: false },
  'Jet Punch':      { power: 60, cat: 'physical', spread: false, priority: 1, punch: true },
  'Liquidation':    { power: 85, cat: 'physical', spread: false },
  'Muddy Water':    { power: 90, cat: 'special', spread: true },
  'Scald':          { power: 80, cat: 'special', spread: false },
  'Surf':           { power: 90, cat: 'special', spread: true },
  'Waterfall':      { power: 80, cat: 'physical', spread: false },
  'Water Pulse':    { power: 60, cat: 'special', spread: false, pulse: true },
  'Water Spout':    { power: 150, cat: 'special', spread: true },
  'Wave Crash':     { power: 120, cat: 'physical', spread: false },
  'Sparkling Aria': { power: 90, cat: 'special', spread: true },
  // Electric
  'Discharge':      { power: 80, cat: 'special', spread: true },
  'Electro Ball':   { power: 0, cat: 'special', spread: false },
  'Electro Shot':   { power: 130, cat: 'special', spread: false },
  'Parabolic Charge': { power: 65, cat: 'special', spread: true },
  'Thunderbolt':    { power: 90, cat: 'special', spread: false },
  'Thunder':        { power: 110, cat: 'special', spread: false },
  'Thunder Punch':  { power: 75, cat: 'physical', spread: false, punch: true },
  'Volt Switch':    { power: 70, cat: 'special', spread: false },
  'Volt Tackle':    { power: 120, cat: 'physical', spread: false },
  'Wild Charge':    { power: 90, cat: 'physical', spread: false },
  'Nuzzle':         { power: 20, cat: 'physical', spread: false },
  'Supercell Slam': { power: 100, cat: 'physical', spread: false },
  // Grass
  'Bullet Seed':    { power: 25, cat: 'physical', spread: false },
  'Energy Ball':    { power: 90, cat: 'special', spread: false },
  'Giga Drain':     { power: 75, cat: 'special', spread: false },
  'Grassy Glide':   { power: 55, cat: 'physical', spread: false, priority: 1 },
  'Leaf Blade':     { power: 90, cat: 'physical', spread: false, slicing: true },
  'Leaf Storm':     { power: 130, cat: 'special', spread: false },
  'Power Whip':     { power: 120, cat: 'physical', spread: false },
  'Seed Bomb':      { power: 80, cat: 'physical', spread: false },
  'Solar Beam':     { power: 120, cat: 'special', spread: false },
  'Wood Hammer':    { power: 120, cat: 'physical', spread: false },
  'Flower Trick':   { power: 70, cat: 'physical', spread: false },
  'Matcha Gotcha':  { power: 80, cat: 'special', spread: true },
  // Ice
  'Blizzard':       { power: 110, cat: 'special', spread: true },
  'Freeze-Dry':     { power: 70, cat: 'special', spread: false },
  'Ice Beam':       { power: 90, cat: 'special', spread: false },
  'Ice Hammer':     { power: 100, cat: 'physical', spread: false, punch: true },
  'Ice Punch':      { power: 75, cat: 'physical', spread: false, punch: true },
  'Ice Shard':      { power: 40, cat: 'physical', spread: false, priority: 1 },
  'Ice Spinner':    { power: 80, cat: 'physical', spread: false },
  'Icicle Crash':   { power: 85, cat: 'physical', spread: false },
  'Icy Wind':       { power: 55, cat: 'special', spread: true },
  'Triple Axel':    { power: 20, cat: 'physical', spread: false },
  // Fighting
  'Aura Sphere':    { power: 80, cat: 'special', spread: false, pulse: true },
  'Body Press':     { power: 80, cat: 'physical', spread: false },
  'Brick Break':    { power: 75, cat: 'physical', spread: false },
  'Close Combat':   { power: 120, cat: 'physical', spread: false },
  'Drain Punch':    { power: 75, cat: 'physical', spread: false, punch: true },
  'Focus Blast':    { power: 120, cat: 'special', spread: false },
  'Hammer Arm':     { power: 100, cat: 'physical', spread: false },
  'High Jump Kick': { power: 130, cat: 'physical', spread: false },
  'Low Kick':       { power: 0, cat: 'physical', spread: false },
  'Mach Punch':     { power: 40, cat: 'physical', spread: false, priority: 1, punch: true },
  'Sacred Sword':   { power: 90, cat: 'physical', spread: false, slicing: true },
  'Superpower':     { power: 120, cat: 'physical', spread: false },
  // Poison
  'Gunk Shot':      { power: 120, cat: 'physical', spread: false },
  'Poison Jab':     { power: 80, cat: 'physical', spread: false },
  'Sludge Bomb':    { power: 90, cat: 'special', spread: false },
  'Sludge Wave':    { power: 95, cat: 'special', spread: true },
  'Dire Claw':      { power: 80, cat: 'physical', spread: false },
  // Ground
  'Bulldoze':       { power: 60, cat: 'physical', spread: true },
  'Drill Run':      { power: 80, cat: 'physical', spread: false },
  'Earth Power':    { power: 90, cat: 'special', spread: false },
  'Earthquake':     { power: 100, cat: 'physical', spread: true },
  'Headlong Rush':  { power: 120, cat: 'physical', spread: false },
  'High Horsepower':{ power: 95, cat: 'physical', spread: false },
  'Scorching Sands':{ power: 70, cat: 'special', spread: false },
  'Stomping Tantrum':{ power: 75, cat: 'physical', spread: false },
  // Flying
  'Acrobatics':     { power: 55, cat: 'physical', spread: false },
  'Air Slash':      { power: 75, cat: 'special', spread: false },
  'Brave Bird':     { power: 120, cat: 'physical', spread: false },
  'Bounce':         { power: 85, cat: 'physical', spread: false },
  'Dual Wingbeat':  { power: 40, cat: 'physical', spread: false },
  'Fly':            { power: 90, cat: 'physical', spread: false },
  'Hurricane':      { power: 110, cat: 'special', spread: false },
  // Psychic
  'Expanding Force':{ power: 80, cat: 'special', spread: false },
  'Extrasensory':   { power: 80, cat: 'special', spread: false },
  'Psychic':        { power: 90, cat: 'special', spread: false },
  'Psychic Fangs':  { power: 85, cat: 'physical', spread: false, bite: true },
  'Psyshock':       { power: 80, cat: 'special', spread: false },
  'Zen Headbutt':   { power: 80, cat: 'physical', spread: false },
  'Lumina Crash':   { power: 80, cat: 'special', spread: false },
  // Bug
  'Bug Bite':       { power: 60, cat: 'physical', spread: false },
  'Bug Buzz':       { power: 90, cat: 'special', spread: false },
  'First Impression':{ power: 90, cat: 'physical', spread: false, priority: 2 },
  'Lunge':          { power: 80, cat: 'physical', spread: false },
  'Megahorn':       { power: 120, cat: 'physical', spread: false },
  'Pollen Puff':    { power: 90, cat: 'special', spread: false },
  'U-turn':         { power: 70, cat: 'physical', spread: false },
  'X-Scissor':      { power: 80, cat: 'physical', spread: false },
  // Rock
  'Ancient Power':  { power: 60, cat: 'special', spread: false },
  'Head Smash':     { power: 150, cat: 'physical', spread: false },
  'Meteor Beam':    { power: 120, cat: 'special', spread: false },
  'Power Gem':      { power: 80, cat: 'special', spread: false },
  'Rock Blast':     { power: 25, cat: 'physical', spread: false },
  'Rock Slide':     { power: 75, cat: 'physical', spread: true },
  'Rock Tomb':      { power: 60, cat: 'physical', spread: false },
  'Stone Axe':      { power: 65, cat: 'physical', spread: false, slicing: true },
  'Stone Edge':     { power: 100, cat: 'physical', spread: false },
  'Salt Cure':      { power: 40, cat: 'physical', spread: false },
  // Ghost
  'Hex':            { power: 65, cat: 'special', spread: false },
  'Last Respects':  { power: 50, cat: 'special', spread: false },
  'Phantom Force':  { power: 90, cat: 'physical', spread: false },
  'Poltergeist':    { power: 110, cat: 'physical', spread: false },
  'Shadow Ball':    { power: 80, cat: 'special', spread: false },
  'Shadow Claw':    { power: 70, cat: 'physical', spread: false },
  'Shadow Sneak':   { power: 40, cat: 'physical', spread: false, priority: 1 },
  'Spirit Shackle': { power: 80, cat: 'physical', spread: false },
  'Rage Fist':      { power: 50, cat: 'physical', spread: false },
  // Dragon
  'Breaking Swipe': { power: 60, cat: 'physical', spread: true },
  'Clanging Scales':{ power: 110, cat: 'special', spread: true },
  'Draco Meteor':   { power: 130, cat: 'special', spread: false },
  'Dragon Claw':    { power: 80, cat: 'physical', spread: false },
  'Dragon Darts':   { power: 50, cat: 'physical', spread: false },
  'Dragon Pulse':   { power: 85, cat: 'special', spread: false, pulse: true },
  'Outrage':        { power: 120, cat: 'physical', spread: false },
  'Scale Shot':     { power: 25, cat: 'physical', spread: false },
  // Dark
  'Crunch':         { power: 80, cat: 'physical', spread: false, bite: true },
  'Dark Pulse':     { power: 80, cat: 'special', spread: false, pulse: true },
  'Darkest Lariat': { power: 85, cat: 'physical', spread: false },
  'Foul Play':      { power: 95, cat: 'physical', spread: false },
  'Knock Off':      { power: 65, cat: 'physical', spread: false },
  'Kowtow Cleave':  { power: 85, cat: 'physical', spread: false, slicing: true },
  'Night Slash':    { power: 70, cat: 'physical', spread: false, slicing: true },
  'Snarl':          { power: 55, cat: 'special', spread: true },
  'Sucker Punch':   { power: 70, cat: 'physical', spread: false, priority: 1 },
  'Throat Chop':    { power: 80, cat: 'physical', spread: false },
  'Lash Out':       { power: 75, cat: 'physical', spread: false },
  'Wicked Blow':    { power: 75, cat: 'physical', spread: false },
  // Steel
  'Bullet Punch':   { power: 40, cat: 'physical', spread: false, priority: 1, punch: true },
  'Flash Cannon':   { power: 80, cat: 'special', spread: false },
  'Gyro Ball':      { power: 0, cat: 'physical', spread: false },
  'Heavy Slam':     { power: 0, cat: 'physical', spread: false },
  'Iron Head':      { power: 80, cat: 'physical', spread: false },
  'Iron Tail':      { power: 100, cat: 'physical', spread: false },
  'Make It Rain':   { power: 120, cat: 'special', spread: true },
  'Meteor Mash':    { power: 90, cat: 'physical', spread: false, punch: true },
  'Smart Strike':   { power: 70, cat: 'physical', spread: false },
  'Steel Beam':     { power: 140, cat: 'special', spread: false },
  'Steel Wing':     { power: 70, cat: 'physical', spread: false },
  'Gigaton Hammer': { power: 160, cat: 'physical', spread: false },
  'Tachyon Cutter': { power: 50, cat: 'special', spread: false },
  // Fairy
  'Dazzling Gleam': { power: 80, cat: 'special', spread: true },
  'Draining Kiss':  { power: 50, cat: 'special', spread: false },
  'Moonblast':      { power: 95, cat: 'special', spread: false },
  'Light of Ruin':  { power: 140, cat: 'special', spread: false },
  'Play Rough':     { power: 90, cat: 'physical', spread: false },
  'Spirit Break':   { power: 75, cat: 'physical', spread: false },
  'Alluring Voice': { power: 80, cat: 'special', spread: false },

  // Fang moves
  'Ice Fang':       { power: 65, cat: 'physical', spread: false, bite: true },
  'Fire Fang':      { power: 65, cat: 'physical', spread: false, bite: true },
  'Thunder Fang':   { power: 65, cat: 'physical', spread: false, bite: true },
  'Poison Fang':    { power: 50, cat: 'physical', spread: false, bite: true },
  'Psychic Fangs':  { power: 85, cat: 'physical', spread: false, bite: true },

  // Additional physical moves
  'Accelerock':     { power: 40, cat: 'physical', spread: false, priority: 1 },
  'Aqua Cutter':    { power: 70, cat: 'physical', spread: false, slicing: true },
  'Aqua Step':      { power: 80, cat: 'physical', spread: false },
  'Avalanche':      { power: 60, cat: 'physical', spread: false },
  'Cross Poison':   { power: 70, cat: 'physical', spread: false },
  'Dragon Rush':    { power: 100, cat: 'physical', spread: false },
  'Dragon Tail':    { power: 60, cat: 'physical', spread: false },
  'Fury Cutter':    { power: 40, cat: 'physical', spread: false },
  'Headbutt':       { power: 70, cat: 'physical', spread: false },
  'Leech Life':     { power: 80, cat: 'physical', spread: false },
  'Low Sweep':      { power: 65, cat: 'physical', spread: false },
  'Psycho Cut':     { power: 70, cat: 'physical', spread: false, slicing: true },
  'Razor Shell':    { power: 75, cat: 'physical', spread: false, slicing: true },
  'Shadow Punch':   { power: 60, cat: 'physical', spread: false, punch: true },
  'Slam':           { power: 80, cat: 'physical', spread: false },
  'Slash':          { power: 70, cat: 'physical', spread: false, slicing: true },
  'Spark':          { power: 65, cat: 'physical', spread: false },

  // Additional special moves
  'Crabhammer':     { power: 100, cat: 'physical', spread: false },
  'Grass Knot':     { power: 0, cat: 'special', spread: false },
  'Signal Beam':    { power: 75, cat: 'special', spread: false },
  'Head Smash':     { power: 150, cat: 'physical', spread: false },

  // Misc additions
  'Dual Chop':      { power: 40, cat: 'physical', spread: false },
  'Poison Tail':    { power: 50, cat: 'physical', spread: false },
  'Night Daze':     { power: 85, cat: 'special', spread: false },
  'Fiery Wrath':    { power: 90, cat: 'special', spread: true },
  'Esper Wing':     { power: 80, cat: 'special', spread: false },
  'Bitter Malice':  { power: 75, cat: 'special', spread: false },
  'Infernal Parade':{ power: 60, cat: 'special', spread: false },
  'Mountain Gale':  { power: 100, cat: 'physical', spread: false },
  'Springtide Storm':{ power: 100, cat: 'special', spread: false },
  'Wildbolt Storm': { power: 100, cat: 'special', spread: false },
  'Sandsear Storm': { power: 100, cat: 'special', spread: false },
  'Bleakwind Storm':{ power: 100, cat: 'special', spread: false },
  'Ruination':      { power: 0, cat: 'special', spread: false },
  'Salt Cure':      { power: 40, cat: 'physical', spread: false },
  'Gigaton Hammer': { power: 160, cat: 'physical', spread: false },
  'Last Respects':  { power: 50, cat: 'special', spread: false },
  'Rage Fist':      { power: 50, cat: 'physical', spread: false },
  'Population Bomb':{ power: 20, cat: 'physical', spread: false },
  'Hydro Steam':    { power: 80, cat: 'special', spread: false },
  'Psyblade':       { power: 80, cat: 'physical', spread: false },
  'Collision Course':{ power: 100, cat: 'physical', spread: false },
  'Electro Drift':  { power: 100, cat: 'special', spread: false },
  'Supercell Slam': { power: 100, cat: 'physical', spread: false },
  'Tachyon Cutter': { power: 50, cat: 'special', spread: false },
  'Hard Press':     { power: 0, cat: 'steel', spread: false },
  'Temper Flare':   { power: 75, cat: 'physical', spread: false },
  'Thunderclap':    { power: 70, cat: 'special', spread: false, priority: 1 },
  'Upper Hand':     { power: 65, cat: 'physical', spread: false, priority: 3 },
  'Mighty Cleave':  { power: 95, cat: 'physical', spread: false, slicing: true },
  'Burning Bulwark': { power: 0, cat: 'status', spread: false },
  'Fickle Beam':    { power: 80, cat: 'special', spread: false },
  'Ivy Cudgel':     { power: 100, cat: 'physical', spread: false },
  'Matcha Gotcha':  { power: 80, cat: 'special', spread: true },
  'Syrup Bomb':     { power: 60, cat: 'special', spread: false },
  'Psychic Noise':  { power: 75, cat: 'special', spread: false },
  'Alluring Voice':  { power: 80, cat: 'special', spread: false },
};

export default MOVE_DATA;
